import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('sale_order_process_type')
export class SaleorderprocessType {

    @PrimaryGeneratedColumn("increment", {name:'sale_order_process_type_id'})
    saleorderprocessTypeId:number;

    @Column("varchar",{
        nullable:false,
        length:20,
        name:"name",
        unique : true
    })
    saleorderprocessTypeCode:string;

      @Column("varchar",{
        nullable:false,
        length:30,
        name:"code"
        })
        saleorderprocessTypeName:string;

        @Column("varchar",{
            nullable:false,
            length:50,
            name:"remarks"
            })
          remarks:string;
      
          @Column("boolean",{
            nullable:false,
            default:true,
            name:"is_active"
            })
          isActive:boolean;
        
          @CreateDateColumn({
            name: "created_at",
            type:"datetime"
          })
          createdAt: Date;
        
          @Column("varchar", {
              nullable: false,
              name: "created_user",
              length:50
          })
          createdUser: string | null;
        
        
          @UpdateDateColumn({
              name: "updated_at",
              type:'datetime'
          })
          updatedAt: Date;
        
          @Column("varchar", {
            nullable: true,
            name: "updated_user",
            length:50
          })
          updatedUser: string | null;
        
          @VersionColumn({
              default:1,
              name: "version_flag"
          })
          versionFlag: number;
          
}
